<template>
<div class="chapter">
<div class="inner_page">
<div id="fm4">
<p class="dedication"><span>For Susan, Anne, Marion, Cynthia, Carolyn</span></p>
<p class="dedication1"><span>and Lisa, all of whom weave</span></p>
<p class="dedication1"><span>their own enchantments at many looms</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5cd50890